import {Box,Text} from "@mantine/core";

export const LoggedOutPage: React.FC = () => {
    return <Box style={{height: "100%", display: "grid", grid: "auto / auto", alignItems: "center"}}>
        <Text size="2.5em" fw={"bolder"}>
            You have successfully logged out.
        </Text>
    </Box>
}